import { Loader2 } from 'lucide-react'

/** Fallback mientras carga el chunk de una ruta (code-splitting con React.lazy). */
export default function RouteFallback() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center" role="status" aria-live="polite">
      <Loader2 className="h-8 w-8 animate-spin text-indigo-600" aria-hidden="true" />
      <span className="sr-only">Cargando…</span>
    </div>
  )
}
